import React from "react";

const FooterNbyulaLogo = ({ className = "" }) => {
  return (
    <svg
      width="50"
      height="50"
      viewBox="0 0 800 800"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M432.795 475.39C400.288 461.424 372.565 442.704 328.202 401.343C243.666 322.958 202.631 233.014 237.367 200.923C258.939 180.628 325.231 181.342 409.054 242.522"
        stroke="url(#paint0_linear_2_288)"
        strokeWidth="29.7138"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M465.194 307.129C528.96 379.333 566.964 458.669 538.082 487.759C526.732 499.11 508.161 501.725 485.221 496.941"
        stroke="url(#paint1_linear_2_288)"
        strokeWidth="29.7138"
        strokeLinecap="round"
      />
      <path
        d="M347.84 362.406C410.833 274.839 486.039 235.825 529.094 257.546C574.259 280.218 558.808 376.817 494.953 472.971C431.098 569.125 342.165 628.85 297 606.178C259.649 587.399 262.977 514.066 301.308 436.453"
        stroke="url(#paint2_linear_2_288)"
        strokeWidth="29.7138"
        strokeLinecap="round"
      />
      <defs>
        <linearGradient
          id="paint0_linear_2_288"
          x1="225"
          y1="332.185"
          x2="449.6"
          y2="222.581"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0135415" stopColor="#E201BE" />
          <stop offset="0.669792" stopColor="#5F2EEA" />
          <stop offset="0.9966" stopColor="#00BFDB" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_2_288"
          x1="465.193"
          y1="403.162"
          x2="567.312"
          y2="373.591"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0135415" stopColor="#E201BE" />
          <stop offset="0.669792" stopColor="#5F2EEA" />
          <stop offset="0.9966" stopColor="#00BFDB" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_2_288"
          x1="270.696"
          y1="431.296"
          x2="567.217"
          y2="273.511"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0135415" stopColor="#E201BE" />
          <stop offset="0.669792" stopColor="#5F2EEA" />
          <stop offset="0.9966" stopColor="#00BFDB" />
        </linearGradient>
      </defs>
    </svg>
  );
};
export default FooterNbyulaLogo;
